var render = function render(){var _vm=this,_c=_vm._self._c;return _c('markdown-field-view',{attrs:{"data-testid":"snippet-description-content"}},[_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html:[$options.safeHtmlConfig]",value:(_vm.description),expression:"description",arg:_vm.$options.safeHtmlConfig}],staticClass:"md js-snippet-description"})])
}
var staticRenderFns = []

export { render, staticRenderFns }